import {useMutation, type UseMutationResult} from '@github-ui/react-query'
import {transferIssueMutation as transferIssueMutationQueryId} from '@github-ui/server-persisted-queries'
import type {
  TransferIssueInput as ServerTransferIssueInput,
  TransferIssueMutationMutation,
} from '@github-ui/server-persisted-queries/types/transferIssueMutation'

import {issueLifecyclePath, submitIssueLifecycleMutation} from './issue-lifecycle-mutation'

export type TransferIssueRouteInput = Omit<ServerTransferIssueInput, 'issueId' | 'clientMutationId'>
export type TransferIssueMutationResponse = TransferIssueMutationMutation

export function useTransferIssueMutation({
  owner,
  repository,
  number,
  onCompleted,
  onError,
}: {
  owner: string
  repository: string
  number: number
  onCompleted?: (response: TransferIssueMutationMutation) => void
  onError?: (error: Error) => void
}): UseMutationResult<TransferIssueMutationMutation, Error, {input: TransferIssueRouteInput}> {
  return useMutation({
    mutationFn: ({input}) => submitTransferIssueMutation({owner, repository, number, input}),
    onSuccess: onCompleted,
    onError,
  })
}

export function submitTransferIssueMutation({
  owner,
  repository,
  number,
  input,
}: {
  owner: string
  repository: string
  number: number
  input: TransferIssueRouteInput
}) {
  return submitIssueLifecycleMutation<TransferIssueMutationMutation>({
    path: `${issueLifecyclePath(owner, repository, number)}/transfer.json`,
    method: 'POST',
    queryId: transferIssueMutationQueryId,
    input,
    errorMessage: 'Issue transfer mutation failed',
    isSuccess: data => data.transferIssue?.issue != null,
    payloadErrors: data => data.transferIssue?.errors,
  })
}
